module.exports = __webpack_public_path__ + "static/media/bg-rain.94c88619.jpg";